<template>
  <div class="qty-box">
    <div class="input-group">
      <button
        type="button"
        @click="decrement()"
        class="btn qty-left-minus"
        data-type="minus"
        data-field
        tabindex="0"
      >
        <svg width="14" height="2" fill="none">
          <use xlink:href="#cart-minus" />
        </svg>
      </button>

      <input
        type="text"
        name="quantity"
        class="form-control input-number qty-input"
        tabindex="0"
        v-model="quantity"
        disabled
      />
      <button
        type="button"
        @click="increment()"
        class="btn qty-right-plus"
        data-type="plus"
        data-field
        tabindex="0"
      >
        <svg width="13" height="14" fill="none">
          <use xlink:href="#cart-plus" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: { qty: Number, isCart: Boolean, index: Number },
  computed: {
    quantity: {
      get() {
        return this.isCart ? this.qty : this.$store.state.cart_store.qty
      },
      set(val) {
        this.$store.commit('SET_QUANTITY', val)
      },
    },
  },
  methods: {
    increment() {
      this.$store.commit('SET_QUANTITY', this.quantity + 1)
      if (this.isCart) {
        this.$store.commit('UPDATE_ITEM_QUANTITY', {
          index: this.index,
          qty: this.quantity + 1,
        })
      }
    },
    decrement() {
      if (this.quantity > 1) {
        this.$store.commit('SET_QUANTITY', this.quantity - 1)
        if (this.isCart) {
          this.$store.commit('UPDATE_ITEM_QUANTITY', {
            index: this.index,
            qty: this.quantity - 1,
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .modal-bottom {
    .qty-box {
      margin-right: auto;
      margin-left: unset;
    }
  }
}
.qty-box {
  margin-left: auto;
  .input-group {
    display: flex;
    flex-wrap: nowrap;
    .btn {
      background: $white;
      border: $px1 solid $light-border;
      border-radius: 0;
      width: $px40;
      padding: 0;
      i {
        color: $light-font;
      }
      &:focus {
        box-shadow: none;
      }
      &.qty-right-plus {
        i {
          color: $color-tertiary;
        }
      }
    }
  }
  .form-control {
    border: $px1 solid $light-border;
    border-left: none;
    border-right: none;
    padding: 0;
    width: $px40;
    height: $px40;
    text-align: center;
    color: $color-tertiary;
    font-weight: 600;
    input {
      text-align: center;
    }
    &:disabled {
      background: $white;
    }
  }
}
</style>
